//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/ugmath.js";
let d=[[],[[["point1","point2","origin","normal"],"AppendPlane",{},4,0],[[],"DeleteLast",{},0,0],[[],"GetNumPlanes",{R_:{num:''}},0,0],[["index"],"GetNthPlane",{R_:{plane:"GeometricUtilities.SectionPlaneData"}},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.InteractiveSectionBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.InteractiveSectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;